import React from 'react'

const CarContext = React.createContext({ configureCar: null })

export default CarContext
